import { render, staticRenderFns } from "./UploadedInvoiceView.vue?vue&type=template&id=22d1b265&scoped=true&"
import script from "./UploadedInvoiceView.vue?vue&type=script&lang=js&"
export * from "./UploadedInvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./UploadedInvoiceView.vue?vue&type=style&index=0&id=22d1b265&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d1b265",
  null
  
)

export default component.exports